import React from "react";
import PropTypes from "prop-types";
import {Button} from "zina-dogi-react";
import {connect} from "react-redux";
import swal from "sweetalert";
import {Badge} from "reactstrap";
import * as cpo from "~/sode/cpo";
import {utils} from "~/utils";
import ApprovalModal from "./approval_modal";

const COLORSTATUS = status => {
    switch (status) {
        case "rejected":
        case "cancelled":
            return "danger";
        case "created":
        case "new":
            return "primary";
        default:
            return "success";
    }
};

const TEXTSTATUS = status => {
    switch (status) {
        case "cancelled":
            return "Cancelled";
        case "created":
            return "Pending approval";
        case "approved":
            return "Approved";
        case "rejected":
            return "Rejected";
        default:
            return "success";
    }
};

class NonSodeDetail extends React.Component {
    static propTypes = {
        cpo: PropTypes.object,
        onStartOET: PropTypes.func
    };

    static header = (props, {cpo}) => {
        return (
            <nav className="navbar">
                <span className="navbar-brand h4">
                    Basic Information Non SODE{`${cpo.hasOwnProperty("non_sode") ? ` #${cpo.non_sode.id}` : ""}`}
                </span>
            </nav>
        );
    };

    circleRef = React.createRef();
    aprovalModalRef = React.createRef();

    state = {
        cancelingCPO: false,
        nonOetRelatedProcess: false,
        blank_oet_received_date: null
    };

    handleChange = date => {
        this.setState({blank_oet_received_date: date});
    };

    get_blank_oet_received_date = () => {
        const {cpo} = this.props;
        const {cpo_register} = cpo;
        let blank_oet_received_date = null;
        if (cpo_register) {
            blank_oet_received_date = this.state.blank_oet_received_date
                ? this.state.blank_oet_received_date
                : utils.strToDate(cpo_register.blank_oet_received_date);
        }
        return blank_oet_received_date;
    };

    openApprovalModal = approve => {
        if (this.aprovalModalRef.current) {
            this.aprovalModalRef.current.toggle(approve);
        }
    };

    render() {
        const {className, cpo} = this.props;
        const defaultCircle = cpo && cpo.circle ? {label: cpo.circle, value: cpo.circle} : null;
        if (defaultCircle && this.circleRef.current && this.circleRef.current.select.state.value !== defaultCircle) {
            this.circleRef.current.select.state.value = defaultCircle;
        }
        return (
            <div className={["cpo_list_detail", className].join(" ")}>
                <ApprovalModal ref={this.aprovalModalRef} onSubmit={this.props.onApproveOrReject}/>
                <div className="content">
                    <div className="row">
                        <div className="col-md-9">
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th scope="col">Status</th>
                                    <td>
                                        {cpo && cpo.non_sode && (
                                            <React.Fragment>
                                                <Badge
                                                    className="text-white"
                                                    color={COLORSTATUS(cpo.status)}
                                                    style={{fontSize: "1em"}}
                                                >
                                                    {cpo.status_display}
                                                </Badge>{" "}
                                                <Badge
                                                    className="text-white"
                                                    color={COLORSTATUS(cpo.non_sode.status)}
                                                    style={{fontSize: "1em"}}
                                                >
                                                    {TEXTSTATUS(cpo.non_sode.status)}
                                                </Badge>
                                            </React.Fragment>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="col">Customer</th>
                                    <td>{cpo && cpo.customer_team_name}</td>
                                </tr>
                                {cpo && cpo.non_sode && (
                                    <React.Fragment>
                                        <tr>
                                            <th scope="col">Non SODE ID</th>
                                            <td>{cpo.non_sode.id}</td>
                                        </tr>

                                        <tr>
                                            <th scope="col">Category</th>
                                            <td>{cpo.non_sode.master_budget.category_display}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Sub category</th>
                                            <td>{cpo.non_sode.master_budget.sub_category_display}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Service unit</th>
                                            <td>{cpo.non_sode.master_budget.service_unit_display}</td>
                                        </tr>

                                        <tr>
                                            <th scope="col">Description</th>
                                            <td>{cpo.non_sode.description}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Requested Budget</th>
                                            <td>{cpo.non_sode.requested_quantity}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Receipt Date</th>
                                            <td>{utils.renderDate(cpo.non_sode.created_at)}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Approval Budget</th>
                                            <td>{cpo.non_sode.approved_quantity}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Approval Date</th>
                                            <td>{utils.renderDate(cpo.non_sode.approval_date)}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Circle</th>
                                            <td>{cpo.circle}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Project</th>
                                            <td>{cpo.project}</td>
                                        </tr>
                                        {/*<tr>*/}
                                        {/*    <th scope="col">Vendor Code</th>*/}
                                        {/*    <td>{cpo.non_sode.vendor_code}</td>*/}
                                        {/*</tr>*/}
                                    </React.Fragment>
                                )}
                                {/*{cpo && (*/}
                                {/*    <tr>*/}
                                {/*        <th scope="col">Project</th>*/}
                                {/*        <td className="editable">{this.renderInput("project", cpo.project)}</td>*/}
                                {/*    </tr>*/}
                                {/*)}*/}
                                {/*{cpo && (*/}
                                {/*    <tr>*/}
                                {/*        <th scope="col">Circle</th>*/}
                                {/*        <td>*/}
                                {/*            <AsyncSelect*/}
                                {/*                ref={this.circleRef}*/}
                                {/*                isClearable*/}
                                {/*                cacheOptions*/}
                                {/*                defaultOptions*/}
                                {/*                loadOptions={val => this.filterVal(val)}*/}
                                {/*            />*/}
                                {/*        </td>*/}
                                {/*    </tr>*/}
                                {/*)}*/}
                                </thead>
                            </table>
                        </div>
                        <div className="col-md-3">
                            <div className="cpo-sidebar">
                                <div className="cpo-controls">
                                    {this.getStartButton()}
                                    {cpo && cpo.non_sode && cpo.non_sode.status === "created" && (
                                        <React.Fragment>
                                            <Button
                                                color="success"
                                                style={{color: "#fff"}}
                                                className="col"
                                                icon="check"
                                                onClick={() => this.openApprovalModal(true)}
                                            >
                                                Approve
                                            </Button>
                                            <Button
                                                color="danger"
                                                style={{color: "#fff"}}
                                                className="col"
                                                icon="times"
                                                onClick={() => this.openApprovalModal(false)}
                                            >
                                                Reject
                                            </Button>
                                        </React.Fragment>
                                    )}
                                    {/*<Button color="primary" className="col" icon="save" onClick={this.onChangePC}>*/}
                                    {/*    Save Changes*/}
                                    {/*</Button>*/}
                                </div>
                                <div className="history-list">
                                    {cpo &&
                                    cpo.historys &&
                                    cpo.historys.map((history, index) => (
                                        <cpo.History key={`history_${index}`} history={history}/>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getStartButton = () => {
        const {cpo} = this.props;
        const hasOet = cpo && cpo.oet && !Array.isArray(cpo.oet);
        const isTemporary = hasOet && cpo.oet.temporary;
        return (
            <React.Fragment>
                {cpo &&
                cpo.non_sode &&
                !(
                    cpo.status === "non_oet_related" ||
                    cpo.non_sode.status === "rejected" ||
                    cpo.non_sode.status === "created"
                ) && (
                    <Button className="col" color="success" icon="play-circle" onClick={this.onStartOET}>
                        {hasOet ? (isTemporary ? "Start OET" : "Go to OET") : "Start OET"}
                    </Button>
                )}
            </React.Fragment>
        );
    };

    saveFinanceData = (values, fns) => {
        const {cpo, update} = this.props;
        if (cpo && cpo.cpo_register) {
            cpo.service
                .updateTcc(cpo.cpo_register.id, values)
                .then(response => {
                    update();
                    swal({
                        title: "Successfully!",
                        text: "Data Saved",
                        icon: "success",
                        timer: 3000,
                        button: true
                    });
                })
                .catch(error => {
                    if (error && error.response) {
                        const {response} = error;
                        if (response.status === 400) {
                            if (response.data.detail) {
                                swal({
                                    title: "Warning!",
                                    text: response.data.detail,
                                    icon: "warning",
                                    timer: 3000,
                                    button: true
                                });
                            } else {
                                swal({
                                    title: "Warning!",
                                    text: `The fields ${Object.keys(response.data)
                                        .map(key => key.replace(/_/g, " "))
                                        .join(", ")
                                        .replace(/,([^,]*)$/, `and $1`)} are mandatory`,
                                    icon: "warning",
                                    button: true
                                });
                            }
                        }
                    } else {
                        console.log({...error});
                    }
                });
        }
    };

    sendActionPending = () => {
        const {cpo, update} = this.props;
        if (cpo && cpo.cpo_register) {
            cpo.service
                .sendNotificationPending(cpo.cpo_register.id)
                .then(response => {
                    if (response.hasOwnProperty("ok") && response.ok === true) {
                        update();
                        swal({
                            title: "Successfully!",
                            text: `Pending action notification sent`,
                            icon: "success",
                            timer: 3000,
                            button: true
                        });
                    }
                })
                .catch(error => {
                    if (error && error.response) {
                        const {response} = error;
                        if (response.status === 400) {
                            swal({
                                title: "Warning!",
                                text: response.data.detail,
                                icon: "warning",
                                timer: 3000,
                                button: true
                            });
                        }
                    }
                });
        }
    };

    filterVal = val => {
        return this.props.listCircles(val);
    };

    renderInput = (id, defaultValue) => {
        const input = document.querySelector(`#${id}`);
        defaultValue = defaultValue || "";
        if (input) input.value = defaultValue;
        return <input id={id} type="text" autoComplete="off" defaultValue={defaultValue}/>;
    };

    onStartOET = ev => {
        const {onStartOET, update, cpo} = this.props;
        let circle = cpo.circle; // this.circleRef.current.select.state.value;
        circle = circle ? circle : "";
        // const project = document.querySelector("#project").value;
        const project = cpo.project;
        onStartOET(project, circle);
        update();
    };

    onChangePC = () => {
        const {cpo, savePC} = this.props;
        let circle = cpo.circle; //this.circleRef.current.select.state.value;
        circle = circle ? circle : "";
        // const project = document.querySelector("#project").value;
        const project = cpo.project
        let cf = cpo_register => {
            swal({
                title: "Successfully updated!",
                text: `Non SODE${cpo.hasOwnProperty("non_sode") ? ` #${cpo.non_sode.id}` : ""}`,
                icon: "success",
                timer: 3000,
                button: true
            });
        };
        savePC(cpo.id, circle, project, cf);
    };

    // download = ev => {
    //     const { id } = this.props.cpo;
    //     cpo.service.download(id);
    // };
    //
    // reParse = ev => {
    //     const { file_parser } = this.props.cpo;
    //     cpo.service
    //         .reParseCpoFile([file_parser])
    //         .then(result => {
    //             swal({
    //                 title: "Sent to queue",
    //                 text: "This customer purchase order has been sent to be reparsed",
    //                 icon: "success",
    //                 timer: 3000,
    //                 button: true
    //             });
    //         })
    //         .catch(errr => {
    //             swal({
    //                 title: "Warning ...",
    //                 text: "Something has gone wrong",
    //                 icon: "warning",
    //                 timer: 3000,
    //                 button: true
    //             });
    //         });
    // };
    //
    // confirmCancel = ev => {
    //     swal({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "warning",
    //         buttons: {
    //             cancel_cpo: {
    //                 visible: true,
    //                 text: "Yes, proceed",
    //                 value: true,
    //                 className: "btn btn-danger"
    //             },
    //             back: {
    //                 visible: true,
    //                 text: "Cancel, go back",
    //                 value: false,
    //                 className: "btn btn-primary"
    //             }
    //         }
    //     }).then(result => {
    //         if (result) {
    //             this.cancel(ev)
    //                 .then(response => {
    //                     console.log(response);
    //                 })
    //                 .catch(error => {
    //                     swal({
    //                         title: "Error",
    //                         text: utils.computeError(error),
    //                         icon: "warning",
    //                         timer: 3000,
    //                         button: true
    //                     });
    //                 });
    //         }
    //     });
    // };
    //
    // confirmReOpen = ev => {
    //     swal({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "info",
    //         buttons: {
    //             yes_re_open: {
    //                 visible: true,
    //                 text: "Yes, proceed",
    //                 value: true,
    //                 className: "btn btn-success"
    //             },
    //             no_re_open: {
    //                 visible: true,
    //                 text: "Cancel",
    //                 value: false,
    //                 className: "btn btn-primary"
    //             }
    //         }
    //     }).then(result => {
    //         if (result) {
    //             this.props.reOpenCPO(this.props.cpo.cpo_register.id);
    //         }
    //     });
    // };
    //
    // cancel = ev => {
    //     return this.props.cancelCPO(this.props.cpo.id, this.props.cpo.number);
    // };
    //
    // nonOetRelated = ev => {
    //     this.setState({ nonOetRelatedProcess: true });
    //     const { cpo, onMarkAsNonOetRelated } = this.props;
    //     onMarkAsNonOetRelated(
    //         cpo.id,
    //         cpo.number,
    //         () =>
    //             swal({
    //                 title: "The customer purchase order has been marked as non oet related successfully.",
    //                 icon: "success"
    //             }),
    //         () => this.setState({ nonOetRelatedProcess: false })
    //     );
    // };
}

const mapDispatchToProps = dispatch => ({
    // cancelCPO: (cpoID, cpoNumber) => dispatch(cpo.actions.cancelCPO(cpoID, cpoNumber)),
    // reOpenCPO: cpoID => dispatch(cpo.actions.reOpenCPO(cpoID)),
    savePC: (cpo_id, circle, project, cb) => dispatch(cpo.actions.updateCPO(cpo_id, circle, project, null, cb))
});

export default connect(null, mapDispatchToProps)(NonSodeDetail);
